var TableFetcherLive = window.TableFetcherLive = (function () {
    const moduleName = 'TableFetcherLive';

    const selectors = {
        betPlace: '#bet-place',
        emptyBetplace: '#live-empty_betplace',
        tbCell: '.events-table__markets-cell',
        tbEventUnique: '#te',
        tbEvent: '.events-table__body-row',

        tbScore: '.events-table__body-score',
        tbMatchTime: '.live-timer__comment',
        tbStartTime: '.live-timer__start-time',
        tbEventInfo: '.events-table__row-comment',

        tbDopCoefCounter: '.events-table__acc-number',
    };

    const EMPTY_COEF = '-',
        EVENT_UPD_INFO = {
            SELF: 'e',
            ID: 'i',
            DOP_COEF_COUNTER: 'x',

            IS_ACTIVE: 'a',
            CURRENT_TIME: 't',
            MATCH_TIME: 'm',
            COMMENT: 'n',
            START_TIME: 'b',
        },
        SCORE_INFO = {
            SELF: 's',
            GENERAL: 'g',
            DETAILED: 't',
            POINTS: 'p',
            INNINGS: 'i',
            ADVANT: 'a',
        },
        SCORE_UNIT = {
            TEAM1: 'f',
            TEAM2: 's',
            FIRST_WON: 'w',
        },
        COEF_UPD_INFO = {
            SELF: 'c',
            ORIGINAL_ID: 'o',
            ACTUAL_ID: 'a',
            COEF_TYPE_ID: 't',
            IS_COEF_VALUE: 's',
            VALUE: 'v',
            TEXT_VALUE: 'x',
        };

    var externalUpdatedCoefs = {};

    var isLightReady = true;

    const isClientCartEnabled = window?.globalAppSettings?.isClientCartEnabled;

    function isInCart(oId) {
        if (isClientCartEnabled) {
            return window.ClientCart.hasOutcome(Number(oId));
        }
        return BettingCart.hasItem(Number(oId));
    }

    function log(msg) {
        app.console.log(
            '%c%s %s',
            'color: #6495ED;',
            '[' + moduleName + ']',
            msg
        );
    }

    function selectByCoefTypeId(coefTypeId) {
        return function (coef) {
            return coef.t === coefTypeId;
        };
    }

    function externalUpdateCoef(originalId, actualId, value, isActive) {
        let cellNode = $('#tcell_' + originalId);
        if (cellNode.length === 0) return;

        let actualIdCurrent = parseInt(cellNode.attr('data-aid'));
        if (isNaN(actualIdCurrent)) actualIdCurrent = 0;

        actualId = parseInt(actualId);
        if (actualIdCurrent < actualId) {

            if (isActive) {
                let valueCurrent = parseFloat(cellNode.attr('data-coefvalue'));
                cellNode.attr('data-aid', actualId)
                    .attr('data-coefvalue', value.toFixed(2))
                    .text(window.Utils.displayCoefValue(value))
                    .removeClass('m-empty');

                if (
                    !cellNode.closest(selectors.tbEvent).hasClass('m-expanded')
                ) {
                    animateCellChange(cellNode, value > valueCurrent);
                }
            } else {
                cellNode
                    .attr('data-aid', actualId)
                    .text(EMPTY_COEF)
                    .addClass('m-empty');
            }

            externalUpdatedCoefs[parseInt(originalId)] = {
                aidFrom: actualIdCurrent,
                aidTo: actualId,
                isActive: isActive,
            };
        } else if (actualIdCurrent === actualId) {
            let isActiveCurrent = !cellNode.hasClass('m-empty');
            if (isActiveCurrent !== isActive) {
                if (isActive) {
                    cellNode.attr('data-coefvalue', value.toFixed(2))
                        .text(window.Utils.displayCoefValue(value))
                        .removeClass('m-empty');
                }
                else {
                    cellNode.text(EMPTY_COEF).addClass('m-empty');
                }
                externalUpdatedCoefs[parseInt(originalId)] = {
                    aidFrom: actualIdCurrent,
                    aidTo: actualId,
                    isActive: isActive,
                };
            }
        }
    }

    function animateCellChange(node, isInc) {
        var deltaClass = 'change ' + (isInc ? 'plus' : 'minus');

        node.addClass(deltaClass);
        setTimeout(function () {
            node.removeClass(deltaClass);
        }, 2000);
    }

    function generateInnerGeneralScore(score) {
        var generalScore = score[SCORE_INFO.GENERAL];
        if (generalScore === undefined) return '';

        return (
            '<span class="events-table__points-item m-points-first m-general">' +
            generalScore[SCORE_UNIT.TEAM1] +
            '</span>' +
            '<span class="events-table__points-divider m-general"> : </span>' +
            '<span class="events-table__points-item m-points-second m-general">' +
            generalScore[SCORE_UNIT.TEAM2] +
            '</span>'
        );
    }

    function updateFirstPeriodSubScore(score, node) {
        let scoreString = '';
        if (score[SCORE_INFO.DETAILED][0] !== undefined) {
            scoreString =
                '<span class="events-table__points-item m-points-first">' +
                '(' +
                score[SCORE_INFO.DETAILED][0][SCORE_UNIT.TEAM1] +
                '</span>' +
                '<span class="events-table__points-divider"> : </span>' +
                '<span class="events-table__points-item m-points-second">' +
                score[SCORE_INFO.DETAILED][0][SCORE_UNIT.TEAM2] +
                ')' +
                '</span>';
            node.addClass('m-grey');
        } else if (score[SCORE_INFO.GENERAL] !== undefined) {
            scoreString =
                '<span class="events-table__points-item m-points-first">' +
                '(' +
                score[SCORE_INFO.GENERAL][SCORE_UNIT.TEAM1] +
                '</span>' +
                '<span class="events-table__points-divider"> : </span>' +
                '<span class="events-table__points-item m-points-second">' +
                score[SCORE_INFO.GENERAL][SCORE_UNIT.TEAM2] +
                ')' +
                '</span>';
            node.removeClass('m-grey');
        }
        node.html(scoreString);
    }

    function generateInnerPointsScore(score, showInnings) {
        var points = score[SCORE_INFO.POINTS],
            advantage = score[SCORE_INFO.ADVANT];
        if (!points && !advantage) return '';

        var innings = showInnings ? score[SCORE_INFO.INNINGS] : 0;
        return [
            '<div class="events-table__points-total">',
            '<span class="events-table__points-item m-points-first' +
                (innings === 1 ? ' m-serve' : '') +
                (advantage === 1 ? ' m-advantage' : '') +
                '">' +
                +(advantage === 0 ? points[SCORE_UNIT.TEAM1] : '40') +
                '</span>',
            '<span class="events-table__points-divider"> : </span>',
            '<span class="events-table__points-item m-points-second' +
                (innings === 2 ? ' m-serve' : '') +
                (advantage === 2 ? ' m-advantage' : '') +
                '">' +
                +(advantage === 0 ? points[SCORE_UNIT.TEAM2] : '40') +
                '</span>',
            '</div>',
        ].join('\n');
    }

    function generateDetailedTableScore(score, showInnings, tableSize) {
        let detailedTable = score[SCORE_INFO.DETAILED];
        if (!detailedTable || !detailedTable.length) return '';

        var innings = showInnings ? score[SCORE_INFO.INNINGS] : 0;

        let startIndex = detailedTable.length - tableSize;
        startIndex = startIndex < 0 ? 0 : startIndex;

        let html =
            '<div class="events-table__row-first' +
            (innings === 1 ? ' m-serve' : '') +
            '">';
        for (let i = startIndex; i <= detailedTable.length - 1; i++) {
            if (startIndex > 0 && i === startIndex) {
                html += '<div class="events-table__row-set">...</div>';
            } else {
                html +=
                    '<div class="events-table__row-set' +
                (detailedTable[i][SCORE_UNIT.FIRST_WON] === 1 //true
                        ? ' m-win'
                        : '') +
                    '">' +
                    detailedTable[i][SCORE_UNIT.TEAM1] +
                    '</div>';
            }
        }

        html +=
            '</div><div class="events-table__row-second' +
            (innings === 2 ? ' m-serve' : '') +
            '">';
        for (let i = startIndex; i <= detailedTable.length - 1; i++) {
            if (startIndex > 0 && i === startIndex) {
                //TODO: REDO
                html += '<div class="events-table__row-set">...</div>';
            } else {
                html +=
                    '<div class="events-table__row-set' +
                (detailedTable[i][SCORE_UNIT.FIRST_WON] === 0 //false
                        ? ' m-win'
                        : '') +
                    '">' +
                    detailedTable[i][SCORE_UNIT.TEAM2] +
                    '</div>';
            }
        }
        html += '</div>';

        return html;
    }

    //оснСчет в теннисе: .events-table__total-score
    //оснСчет в футболе .events-table__body-score TODO: привести к одному
    //табличный счет: .events-table__sets
    function updateScore(eventNode, event) {
        let scoreNode = eventNode.find(selectors.tbScore),
            newScoreString = JSON.stringify(event[SCORE_INFO.SELF]);

        //Just GeneralScore

        if (scoreNode.attr('tooltip-event-score'))
            scoreNode.attr('tooltip-event-score', newScoreString);

        if (scoreNode.attr('data-event-score') !== newScoreString) {
            scoreNode
                .html(generateInnerGeneralScore(event[SCORE_INFO.SELF]))
                .addClass('change');

            let subScoreNode = eventNode.find('.events-table__score-expanded');
            if (subScoreNode.length) {
                updateFirstPeriodSubScore(event[SCORE_INFO.SELF], subScoreNode);
            }
            setTimeout(function () { scoreNode.removeClass('change'); }, 2000);
        }

        scoreNode.attr('data-event-score', newScoreString);

        //General Score + Detailed Score Table
        let tennisScoreNode = eventNode.find('.events-table__scoring');

        if (
            !tennisScoreNode.length ||
            tennisScoreNode.attr('data-event-score') === newScoreString
        ) return;

        var prevScore = JSON.parse(tennisScoreNode.attr('data-event-score'));



        if (tennisScoreNode.attr('tooltip-event-score'))
            tennisScoreNode.attr('tooltip-event-score', newScoreString);

        tennisScoreNode.attr('data-event-score', newScoreString);

        if (
            JSON.stringify(event[SCORE_INFO.SELF][SCORE_INFO.DETAILED]) !==
                JSON.stringify(prevScore[SCORE_INFO.DETAILED]) ||
            event[SCORE_INFO.SELF][SCORE_INFO.INNINGS] !==
                prevScore[SCORE_INFO.INNINGS]
        ) {
            let setsNode = eventNode.find('.events-table__sets');
            let tableSize = setsNode.attr('data-tsize');
            let showInnings = setsNode.attr('show-innings') !== undefined;
            setsNode.html(
                generateDetailedTableScore(
                    event[SCORE_INFO.SELF],
                    showInnings,
                    tableSize
                )
            );
        }

        if (
            JSON.stringify(event[SCORE_INFO.SELF][SCORE_INFO.GENERAL]) !==
            JSON.stringify(prevScore[SCORE_INFO.GENERAL])
        ) {
            eventNode
                .find('.events-table__score')
                .html(generateInnerGeneralScore(event[SCORE_INFO.SELF]));
            let totalScore = tennisScoreNode.find('.events-table__total-score');
            totalScore.addClass('change');
            setTimeout(function () {
                totalScore.removeClass('change');
            }, 2000);
        }

        //TODO: Вот тут явно можно производительнее сделать
        delete event[SCORE_INFO.SELF][SCORE_INFO.DETAILED];
        delete prevScore[SCORE_INFO.DETAILED];
        delete event[SCORE_INFO.SELF][SCORE_INFO.GENERAL];
        delete prevScore[SCORE_INFO.GENERAL];

        if (
            JSON.stringify(event[SCORE_INFO.SELF]) !== JSON.stringify(prevScore)
        ) {
            var pointsNode = eventNode.find('.events-table__points');
            var showInnings = pointsNode.attr('show-innings') !== undefined;
            var pointsInnerHtml = generateInnerPointsScore(
                event[SCORE_INFO.SELF],
                showInnings
            );
            pointsNode.html(pointsInnerHtml);

            if (pointsInnerHtml.length) pointsNode.removeClass('m-empty');
            else pointsNode.addClass('m-empty');
        }
    }

    function handleLightFetch(data) {
        app.console.time('Fetched(Light)');

        for (
            var eventIndex = 0;
            eventIndex < data.length;
            eventIndex++
        ) {
            var event = data[eventIndex],
                eventNode = $(
                    selectors.tbEventUnique + event[EVENT_UPD_INFO.ID]
                );

            if (eventNode.length < 1) {
                continue;
            }

            //currentTime
            let currentTimeNode = eventNode.find('.live-timer__current-time');
            if (currentTimeNode.text() !== event[EVENT_UPD_INFO.CURRENT_TIME])
                currentTimeNode.text(event[EVENT_UPD_INFO.CURRENT_TIME]);

            updateScore(eventNode, event);

            //dopCoefCounters
            var NECESSARY_COEF_COUNTERS = 5;
            if (
                eventNode.find(selectors.tbDopCoefCounter + '.m-0').text() !==
                event[EVENT_UPD_INFO.DOP_COEF_COUNTER].toString()
            ) {
                eventNode
                    .find(selectors.tbDopCoefCounter + '.m-0')
                    .text(event[EVENT_UPD_INFO.DOP_COEF_COUNTER]);
                if (event[EVENT_UPD_INFO.DOP_COEF_COUNTER] >= 0) {
                    for (
                        var index = 0;
                        index < NECESSARY_COEF_COUNTERS;
                        index++
                    ) {
                        eventNode
                            .find(selectors.tbDopCoefCounter + '.m-' + index)
                            .text(event[EVENT_UPD_INFO.DOP_COEF_COUNTER]);
                    }
                }
            }

            //isActive (isOver included)
            if (!!event[EVENT_UPD_INFO.IS_ACTIVE]) {
                eventNode.removeClass('m-blocked');
            } else {
                eventNode.addClass('m-blocked');
                continue;
            }

            //coefs
            var isEventExpanded = eventNode.hasClass('m-expanded');
            eventNode.find(selectors.tbCell).each(function (ind) {
                var cellNode = $(this),
                    coefTypeId = cellNode.data('ctid'),
                    newCoef = event[COEF_UPD_INFO.SELF].filter(
                        selectByCoefTypeId(coefTypeId)
                    )[0];

                if (!newCoef) {
                    if (!cellNode.hasClass('m-empty')) {
                        let oid = parseInt(cellNode.attr('data-oid'));
                        if (!isNaN(oid)) {
                            let externalUpdateData = externalUpdatedCoefs[oid];
                            if (
                                !!externalUpdateData &&
                                externalUpdateData.aidTo ===
                                    externalUpdateData.aidFrom &&
                                externalUpdateData.isActive
                            ) {
                                return true;
                            }
                        }

                        cellNode
                            .attr('data-aid', null)
                            .attr('data-oid', null)
                            .attr('id', null)
                            .text(EMPTY_COEF)
                            .addClass('m-empty')
                            .removeClass('active m-txt');
                    }
                } else {
                    if (!newCoef[COEF_UPD_INFO.ACTUAL_ID])
                        newCoef[COEF_UPD_INFO.ACTUAL_ID] =
                            newCoef[COEF_UPD_INFO.ORIGINAL_ID];

                    if (!!newCoef[COEF_UPD_INFO.IS_COEF_VALUE]) {
                        let externalUpdateData =
                            externalUpdatedCoefs[
                                newCoef[COEF_UPD_INFO.ORIGINAL_ID]
                            ];
                        if (externalUpdateData !== undefined) {
                            if (
                                externalUpdateData.aidTo >
                                newCoef[COEF_UPD_INFO.ACTUAL_ID]
                            ) {
                                return true;
                            } else if (
                                externalUpdateData.aidTo ===
                                    newCoef[COEF_UPD_INFO.ACTUAL_ID] &&
                                externalUpdateData.aidTo ===
                                    externalUpdateData.aidFrom
                            ) {
                                let isActiveCurrent =
                                    !cellNode.hasClass('m-empty');
                                if (
                                    isActiveCurrent ===
                                    externalUpdateData.isActive
                                ) {
                                    return true;
                                }
                            }
                            delete externalUpdatedCoefs[
                                newCoef[COEF_UPD_INFO.ORIGINAL_ID]
                            ];
                        }

                        if (newCoef[COEF_UPD_INFO.VALUE] > 1) {
                            let currentTextFloat = parseFloat(cellNode.attr('data-coefvalue'));
                            if ( currentTextFloat !== newCoef[COEF_UPD_INFO.VALUE]) {
                                cellNode
                                    .attr('data-aid', newCoef[COEF_UPD_INFO.ACTUAL_ID])
                                    .attr('data-oid', newCoef[COEF_UPD_INFO.ORIGINAL_ID])
                                    .attr('id', 'tcell_' + newCoef[COEF_UPD_INFO.ORIGINAL_ID])
                                    .attr('data-coefvalue', newCoef[COEF_UPD_INFO.VALUE].toFixed(2))
                                    .html(
                                        '<span class="coef-animation-text">' +
                                            window.Utils.displayCoefValue(newCoef[COEF_UPD_INFO.VALUE]) +
                                        '</span>'
                                    );

                                if (cellNode.hasClass('m-empty')) {
                                    cellNode.removeClass('m-empty');
                                } else if (!isEventExpanded) {
                                    animateCellChange(
                                        cellNode,
                                        newCoef[COEF_UPD_INFO.VALUE] >
                                            currentTextFloat
                                    );
                                }
                                isInCart(newCoef[COEF_UPD_INFO.ORIGINAL_ID])
                                    ? cellNode.addClass('active')
                                    : cellNode.removeClass('active');
                            }
                        } else {
                            if (!cellNode.hasClass('m-empty')) {
                                cellNode
                                    .attr('data-aid', null)
                                    .attr('data-oid', null)
                                    .attr('id', null)
                                    .text(EMPTY_COEF)
                                    .addClass('m-empty')
                                    .removeClass('active');
                            }
                        }
                    } else {
                        if (cellNode.attr('data-coefvalue') !== newCoef[COEF_UPD_INFO.TEXT_VALUE]) {
                            cellNode
                                .attr('data-aid', null)
                                .attr('data-coefvalue', newCoef[COEF_UPD_INFO.TEXT_VALUE])
                                .text(newCoef[COEF_UPD_INFO.TEXT_VALUE])
                                .addClass('m-txt')
                                .removeClass('m-empty');
                        }
                    }
                }
            });
        }
        app.console.timeEnd('Fetched(Light)');
    }

    var handleFullFetch = (function () {
        var oldResults;
        return {
            preProc: function () {
                oldResults = [];
                $(selectors.betPlace)
                    .find(selectors.tbCell + '[data-oid]')
                    .each(function () {
                        oldResults[$(this).data('oid')] = $(this).text().trim();
                    });
            },
            postProc: function () {
                var avaliableCells = $(selectors.betPlace).find(
                    selectors.tbEvent +
                        ':not(.m-blocked) ' +
                        selectors.tbCell +
                        '[data-oid]'
                );
                for (key in oldResults) {
                    var cellNode = avaliableCells
                        .filter('[data-oid=' + key + ']')
                        .first();
                    if (!cellNode) continue;
                    var currentText = cellNode.attr('data-coefvalue');
                    if (currentText === oldResults[key]) continue;
                    animateCellChange(cellNode, currentText > oldResults[key]);
                }
                oldResults = [];
            },
        };
    })();

    var fullIntervalId, lightIntervalId;
    var fullInterval = 30 * 1000,
        lightInterval = globalAppSettings.lightFetchTimeout;

    var fullUrl = undefined;
    var currentSportType;
    const fullStandardUrl = '/Live/UpdateBetPlace',
        fullFavoritesUrl = '/Live/UpdateFavoritesBetPlace',
        lightUrlEventService = globalAppSettings.api.prematchServiceUrl + '/api/live/table/fetch',
        lightUrlDiffFetch = globalAppSettings.api.prematchServiceUrl + '/api/live/table/fetch/diff';

    const isDiffFetchEnabled = globalAppSettings.isDiffLightFetchEnabled;

    function fullFetch() {
        if (fullUrl === undefined) {
            return;
        }

        var requestData = {};
        if (currentSportType !== undefined) {
            requestData.sportType = currentSportType;
        }

        stopLight();
        //handleFullFetch.preProc();

        Ajax.getJson(fullUrl, {
            data: requestData,
            success: function () {
                app.ModeTableLive.update();
                app.ModeTableLive.count() === 0
                    ? $(selectors.emptyBetplace).addClass('active')
                    : $(selectors.emptyBetplace).removeClass('active');

                //handleFullFetch.postProc();
                app.VerticalMenu.dispose();
                app.VerticalMenu.init();
                log('Fetched(Full)');
                startLight();
                document.dispatchEvent(new CustomEvent('updateLiveTable'));
            },
        });
    }

    var errorsLeft = 3;
    function lightFetchEventService() {
        if (app.ModeTableLive.count() === 0) {
            log('Nothing to Fetch(Light)');
            return;
        }

        if (!isLightReady) {
            log('Not Ready: Fetch(Light)');
        } else {
            isLightReady = false;
            $.ajax({
                method: 'GET',
                async: true,
                xhrFields: {
                    withCredentials: true,
                },
                beforeSend: function (request) {
                    request.setRequestHeader('bb_appSource', globalAppSettings.api.appSource);
                    request.setRequestHeader('bb_lang', globalAppSettings.lang);
                    if (globalAppSettings.api.authToken) {
                        request.setRequestHeader('Authorization', `Bearer ${globalAppSettings.api.authToken}`);
                    }
                },
                url: lightUrlEventService,
                success: function (data) {
                    handleLightFetch(data);
                    data = null;
                    isLightReady = true;
                },
                error: function (data) {
                    log('LIGHTFETCH ERROR!', data);
                    if (errorsLeft-- <= 0) {
                        Ajax.redirect('/live');
                    }
                    isLightReady = true;
                },
            });
        }
    }


    var lastRequestTime;
    function lightFetchDiff() {
        if (app.ModeTableLive.count() === 0) {
            log('Nothing to Fetch(Light)');
            return;
        }

        if (!isLightReady) {
            log('Not Ready: DiffFetch(Light)');
        } else {
            isLightReady = false;
            $.ajax({
                method: 'GET',
                async: true,
                xhrFields: {
                    withCredentials: true,
                },
                data: { lrt: lastRequestTime },
                beforeSend: function (request) {
                    request.setRequestHeader('bb_appSource', globalAppSettings.api.appSource);
                    request.setRequestHeader('bb_lang', globalAppSettings.lang);
                    if (globalAppSettings.api.authToken) {
                        request.setRequestHeader('Authorization', `Bearer ${globalAppSettings.api.authToken}`);
                    }
                },
                url: lightUrlDiffFetch,
                success: function (data) {
                    lastRequestTime = Math.floor(new Date().getTime() / 1000);
                    handleLightFetch(data);
                    data = null;
                    isLightReady = true;
                },
                error: function (data) {
                    log('DIFF FETCH ERROR!', data);
                    if (errorsLeft-- <= 0) {
                        Ajax.redirect('/live');
                    }
                    isLightReady = true;
                },
            });
        }
    }

    function stopFull() {
        clearInterval(fullIntervalId);
        log('FULL_UPD STOP');
    }

    function startFull() {
        clearInterval(fullIntervalId);
        fullIntervalId = setInterval(fullFetch, fullInterval);
        //log('FULL_UPD START');
    }

    function stopLight() {
        clearInterval(lightIntervalId);
        log('LIGHT_UPD STOP');
        isLightReady = false;
    }

    function startLight() {
        isLightReady = true; //TODO: look back in history.
        clearInterval(lightIntervalId);
        if (isDiffFetchEnabled)
            lightIntervalId = setInterval(lightFetchDiff, lightInterval);
        else
            lightIntervalId = setInterval(lightFetchEventService, lightInterval);
        log('LIGHT_UPD START');
    }

    function refreshFullFetch() {
        stopFull();
        startFull();
    }

    var stop = function () {
        stopFull();
        stopLight();
    };

    var start = function () {
        startLight();
        startFull();
    };

    var setMode = {
        standard: function () {
            fullUrl = fullStandardUrl;
        },
        favorites: function () {
            fullUrl = fullFavoritesUrl;
        },
        standartSingleSport: function (sportType) {
            fullUrl = fullStandardUrl;
            currentSportType = sportType;
        },
    };

    return {
        start: start,
        stop: stop,
        full: fullFetch,
        refreshFull: refreshFullFetch,
        blink: animateCellChange,
        updateCoef: externalUpdateCoef,
        setMode: setMode,
    };
})();
